var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 20.666V13.066C30.6666 10.8258 30.6666 9.7057 30.2307 8.85005C29.8472 8.09741 29.2353 7.48548 28.4826 7.10199C27.627 6.66602 26.5069 6.66602 24.2666 6.66602H15.7333C13.4931 6.66602 12.373 6.66602 11.5174 7.10199C10.7647 7.48548 10.1528 8.09741 9.76929 8.85005C9.33331 9.7057 9.33331 10.8258 9.33331 13.066V26.9327C9.33331 29.1729 9.33331 30.293 9.76929 31.1486C10.1528 31.9013 10.7647 32.5132 11.5174 32.8967C12.373 33.3327 13.4931 33.3327 15.7333 33.3327H20M22.6666 18.666H14.6666M17.3333 23.9993H14.6666M25.3333 13.3327H14.6666M23.3333 29.3327L26 31.9993L32 25.9993",
    stroke: "#395BA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyDoc);
export default __webpack_public_path__ + "static/media/PolicyDoc.8842a1d7cde5b0486584bc88bc0c05b2.svg";
export { ForwardRef as ReactComponent };